import {BehaviorSubject, Observable} from 'rxjs';

// Deprecated
export abstract class IDefaultNoCacheService<Entity> {

    readonly loading$: Observable<boolean> = new BehaviorSubject(false);
    readonly error$: Observable<any> = new BehaviorSubject(undefined);

    protected constructor() {
    }

    abstract getEntityId(entity: Entity): string | number;

    protected setLoading(loading: boolean) {
        (this.loading$ as BehaviorSubject<boolean>).next(loading);
    }

    protected setError(error: any) {
        (this.error$ as BehaviorSubject<any>).next(error);
    }

    get loadingSnapshot(): boolean {
        return (this.loading$ as BehaviorSubject<boolean>).getValue();
    }
}
